module.exports = __webpack_public_path__ + "static/media/highlighter.be3cbfce.svg";